import { FaBars, FaEdit, FaLock, FaUser } from "react-icons/fa";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import { auth, db } from "./Firebase";

export default function Users() {

    const [sidebarOpen, setSidebarOpen] = useState(false);

    const [users, setUsers] = useState([]);

    function fetchdata() {
        db.collection("users").onSnapshot((snapshot) => {
            setUsers(snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })));
        });
    }

    useEffect(() => {
        fetchdata();
    }, []);

    function handleEdit(userId) {
        // Example: navigate to edit page or open modal
        console.log("Edit user:", userId);
        // You can redirect to an edit form:
        // navigate(`/edit-user/${userId}`);
    }

    function handleLock(userId, currentStatus) {
        // Determine the new status
        const newStatus = currentStatus === "Locked" ? "Active" : "Locked";

        db.collection("users").doc(userId).update({
            Status: newStatus
        })
            .then(() => {
                console.log(`User ${userId} status changed to ${newStatus}`);
            })
            .catch((err) => {
                console.error("Error updating user status:", err);
            });
    }

    // function submitform(e) {
    //     e.preventDefault();

    //     const data = new FormData(e.currentTarget);
    //     const fullname = data.get("fullname");
    //     const email = data.get("email");
    //     const contact = data.get("contact");
    //     const role = data.get("role");
    //     const password = data.get("password");
    //     const isActive = data.get("active") === "on" ? "Active" : "Locked"; // Based on checkbox

    //     db.collection("users")
    //         .add({
    //             Fullname: fullname,
    //             Email: email,
    //             Contact: contact,
    //             Role: role,
    //             Password: password,
    //             Status: isActive,
    //             lastLogin: null, // default value
    //             createdAt: new Date(), // add timestamp
    //         })
    //         .then(() => {
    //             alert("New user added successfully!");
    //             e.target.reset();
    //             e.target.fullname.focus();
    //         })
    // }

    // import { auth, db } from "./Firebase";

    // import { auth, db } from "./Firebase";

    function submitform(e) {
        e.preventDefault();

        var data = new FormData(e.currentTarget);
        var fullname = data.get("fullname");
        var email = data.get("email").trim().toLowerCase();
        var password = data.get("password").trim();
        var contact = data.get("contact");
        var role = data.get("role");
        var isActive = data.get("active") === "on" ? "Active" : "Locked";

        // First create user in Firebase Auth
        auth.createUserWithEmailAndPassword(email, password)
            .then((userCredential) => {
                let user = userCredential.user;

                // Then save extra info in Firestore
                db.collection("users").doc(user.uid).set({
                    Fullname: fullname,
                    Email: email,
                    Contact: contact,
                    Role: role,
                    Status: isActive,
                    createdAt: new Date(),
                    lastLogin: null,
                })
                    .then(() => {
                        alert("User added successfully ✅");
                        e.target.reset(); // clear form
                    })
                    .catch((err) => {
                        alert("Error saving user: " + err.message);
                    });
            })
            .catch((err) => {
                alert("Error creating user: " + err.message);
            });
    }




    return (
        <>
            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />
                    {/* Main Content */}
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 offset-0 offset-lg-0 offset-md-0 ps-5">

                        <div className="container-fluid px-5">
                            {/* Header */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h4>User Management</h4>
                                    <p className="text-muted mb-0">Manage admin panel access and roles</p>
                                </div>
                                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addUserModal">+ Add User</button>
                            </div>

                            {/* Table */}
                            <div className="table-responsive shadow-sm rounded">
                                <table className="table align-middle mb-0">
                                    <thead className="table-primary">
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Role</th>
                                            <th>Last Login</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.map((row) => (
                                            <tr>
                                                <td>{row.Fullname}</td>
                                                <td>{row.Email}</td>
                                                <td>{row.Role}</td>
                                                <td>
                                                    {row.lastLogin
                                                        ? new Date(row.lastLogin.seconds * 1000).toLocaleString()
                                                        : "Never Logged In"}
                                                </td>
                                                <td>{row.Status}</td>
                                                <td>
                                                    <button className="btn btn-link text-primary p-0 me-2" onClick={() => handleEdit(row.id)}>
                                                        <FaEdit />
                                                    </button>
                                                    <button className="btn btn-link text-warning p-0"
                                                        onClick={() => handleLock(row.id, row.Status)}>
                                                        <FaLock />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            {/* <!-- Add New User Modal --> */}
            <div className="modal fade" id="addUserModal" tabindex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        {/* <!-- Modal Header --> */}
                        <div className="modal-header">
                            <h5 className="modal-title fw-bold text-primary">Add New User</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        {/* <!-- Modal Body --> */}
                        <div className="modal-body">
                            <form onSubmit={submitform}>

                                <div className="mb-3">
                                    <label className="form-label">Full Name <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" name="fullname" placeholder="Enter full name" required />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Email Address <span className="text-danger">*</span></label>
                                    <input type="email" className="form-control" name="email" placeholder="Enter email" required />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Contact <span className="text-danger">*</span></label>
                                    <input type="tel" className="form-control" name="contact" placeholder="Enter contact no." required />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Role <span className="text-danger">*</span></label>
                                    <select className="form-select" name="role" required >
                                        <option value="">Select Role</option>
                                        <option value="Super Admin">Super Admin</option>
                                        <option value="Manager">Manager</option>
                                        <option value="Staff">Staff</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Password <span className="text-danger">*</span></label>
                                    <input type="password" className="form-control" name="password" placeholder="Enter password" required />
                                </div>

                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" name="active" checked />
                                    <label className="form-check-label">Active</label>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <button type="button" className="btn btn-outline-secondary me-2" data-bs-dismiss="modal">Cancel</button>
                                    <button type="submit" className="btn btn-primary align-items-center d-flex">
                                        <FaUser />&nbsp; Add User
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div >
            </div >

        </>
    )
}